module.exports = __webpack_public_path__ + "static/media/left-arrow.dbf0d673.png";